import React, { useState } from "react";
import { api, apiError } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Sparkles, Upload, Loader2 } from "lucide-react";
import { toast } from "sonner";

export function AutofillPanel({ onParsed }) {
  const [loading, setLoading] = useState(false);
  async function upload(e) {
    const file = e.target.files?.[0]; e.target.value = "";
    if (!file) return; setLoading(true);
    try {
      const fd = new FormData(); fd.append("file", file);
      const { data } = await api.post("/ocr/parse-bill", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onParsed(data.parsed, data.preview); toast.success("Bill read · please review");
    } catch (err) { toast.error(apiError(err)); } finally { setLoading(false); }
  }
  return (
    <Card className="p-4 border-dashed border-2 border-purple-300 bg-purple-50/40" data-testid="di-autofill-panel">
      <div className="flex items-center gap-2 text-sm font-semibold text-purple-800"><Sparkles className="h-4 w-4" />Autofill this bill</div>
      <p className="text-xs text-slate-500 mt-1">Upload a JPG, PNG or PDF. AI reads party, items, charges, TP, payments and more. You review everything before it fills in.</p>
      <label className="mt-3 flex items-center justify-center gap-2 h-10 rounded-md border border-purple-300 bg-white text-sm text-purple-700 cursor-pointer hover:bg-purple-50">
        {loading ? <><Loader2 className="h-4 w-4 animate-spin" />Reading bill...</> : <><Upload className="h-4 w-4" />Upload JPG / PNG / PDF</>}
        <input type="file" accept=".jpg,.jpeg,.png,.pdf" className="hidden" disabled={loading} onChange={upload} data-testid="di-autofill-upload" />
      </label>
    </Card>
  );
}
